import type { ReactNode } from 'react';

export type ColumnDef<T> = {
  id: string;
  header: ReactNode;
  cell: (item: T) => ReactNode;
  skeleton?: () => ReactNode;
  width?: number;
};

export const column = <T>(def: ColumnDef<T>): ColumnDef<T> => def;

export const toGridTemplateColumns = <T>(columns: ColumnDef<T>[]): string =>
  columns.map((col) => (col.width != null ? `${col.width}px` : 'minmax(0, 1fr)')).join(' ');
